<template>
    <BaseContainer>
        <span slot="principal">
            <v-content class="pr-2 pl-2">
                <v-toolbar class="ma-2" style="border-radius: 30px;" dense>
                    <v-btn icon link to="/">
                        <v-icon>mdi-arrow-left</v-icon>
                    </v-btn>

                    <v-toolbar-title v-show="$vuetify.breakpoint.smAndUp">Cobranças</v-toolbar-title>

                    <v-spacer/>

                    <v-tabs
                        v-if="abas.length > 1"
                        v-model="aba"
                        centered
                        show-arrows
                        class="abas"
                    >
                        <v-tab v-for="item in abas" :key="item.chave">
                            <v-icon left small>{{ item.icone }}</v-icon>
                            {{ item.titulo }}
                        </v-tab>
                    </v-tabs>

                    <v-spacer/>
                </v-toolbar>

                <div v-if="!abas.length" class="pa-12 text-center grey--text">
                    <v-icon large color="grey">mdi-lock-outline</v-icon>
                    <div class="mt-2">Seu usuário não tem permissão para consultar cobranças.</div>
                    <div class="text-caption">
                        Peça a um diretor para liberar em Usuários → Permissões.
                    </div>
                </div>

                <v-tabs-items v-else v-model="aba" touchless class="transparente">
                    <v-tab-item v-for="item in abas" :key="item.chave">
                        <TabCobrancas v-if="item.chave === 'cobrancas'"/>
                        <TabTaxasMp v-else/>
                    </v-tab-item>
                </v-tabs-items>
            </v-content>
        </span>
    </BaseContainer>
</template>

<script>
import BaseContainer from '@/components/BaseContainer';
import TabCobrancas from './TabCobrancas';
import TabTaxasMp from './TabTaxasMp';

export default {
    name: 'Cobrancas',

    components: {
        BaseContainer,
        TabCobrancas,
        TabTaxasMp,
    },

    data: () => ({
        aba: 0,
    }),

    computed: {
        abas() {
            const lista = [];

            if (this.checkPermission('zapercontrol_cobrancas_consultar')) {
                lista.push({ chave: 'cobrancas', titulo: 'Cobranças', icone: 'mdi-file-document-outline' });
            }

            if (this.checkPermission('zapercontrol_cobrancas_taxas_mp_consultar')) {
                lista.push({ chave: 'taxas', titulo: 'Taxas Mercado Pago', icone: 'mdi-percent-outline' });
            }

            return lista;
        },
    },
};
</script>

<style scoped>
.abas {
    max-width: 460px;
}

.transparente >>> .v-window__container {
    background: transparent;
}
</style>
